import React from "react";
import cx from "classnames";
function WithAside({ children, className, ...props }) {
    return (<section className={cx("with-aside", className)} {...props}>
      {children}
    </section>);
}
export default WithAside;
export function Aside({ children, className, ...props }) {
    return (<div className={cx("aside", className)} {...props}>
      {children}
    </div>);
}
function MainContentCard({ children, className, ...props }) {
    return (<div id={cx("main-content-card", className)} className={cx("main-content-card", className)} {...props}>
      {children}
    </div>);
}
export function Main({ children, className, ...props }) {
    return (<div className={cx("main", className)} {...props}>
      <MainContentCard>{children}</MainContentCard>
    </div>);
}
export function MainHeader({ children, className, ...props }) {
    return (<div id={cx("main-header", className)} className={cx("main-header", className)} {...props}>
      {children}
    </div>);
}
export function MainBody({ children, className, ...props }) {
    return (<div id={cx("main-body", className)} className={cx("main-body", className)} {...props}>
      {children}
    </div>);
}
export function MainFooter({ children, className, ...props }) {
    return (<div id={cx("main-footer", className)} className={cx("main-footer", className)} {...props}>
      {children}
    </div>);
}
